import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { MapsURL, SearchURL, TokenCredential, Aborter } from 'azure-maps-rest';
import { Observable, BehaviorSubject } from 'rxjs';
import { SERVICE_PROVIDER_SITE_MAP_AUTH_URL, AZURE_MAP_CLIENT_ID } from 'src/app/tokens';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  public searchURL!: SearchURL;
  private sub = new BehaviorSubject<string>("");
  private currentToken!: string;

  constructor(private http: HttpClient, @Inject(SERVICE_PROVIDER_SITE_MAP_AUTH_URL) private serviceProviderSiteMapAuthUrl: any,
    @Inject(AZURE_MAP_CLIENT_ID) private azureMapClientID: any) {
    this.init();
  }

  public loadApiKey(key: string) {
    var tokenCredential = new TokenCredential(this.azureMapClientID, key);
    this.startTimer(tokenCredential);
    this.buildPipeline(tokenCredential);
    this.sub.next(key);
  }

  init() {
    this.getApiKey().subscribe((token: string) => {
      this.currentToken = token;
      this.loadApiKey(token)
    });
  }

  public getApiKeyObservable() {
    return this.sub.asObservable();
  }

  public ngOnDestroy() {
    this.sub.complete();
  }

  public getApiKey(): Observable<string> {
    return this.http.get(this.serviceProviderSiteMapAuthUrl, { responseType: 'text' });
  }

  private startTimer(credential: TokenCredential) {
    const renewToken = () => {
      try {
        this.getApiKey().subscribe(
          (key: string) => {
            credential.token = key;
            this.buildPipeline(credential);
            this.sub.next(key);
            tokenRenewalTimer = setTimeout(renewToken, this.getExpiration(key));
          }
        );
      } catch (error) {
        clearTimeout(tokenRenewalTimer);
      }
    };
    let tokenRenewalTimer = setTimeout(renewToken, this.getExpiration(credential.token));
  }

  private getExpiration(jwtToken: string) {
    // Decode the JSON Web Token (JWT) to get the expiration time stamp.
    const json = atob(jwtToken.split(".")[1]);
    const decode = JSON.parse(json);

    // Return the milliseconds remaining until the token must be renewed.
    // Reduce the time until renewal by 5 minutes to avoid using an expired token.
    // The exp property is the time stamp of the expiration, in seconds.
    const renewSkew = 1000;
    return (1000 * decode.exp) - Date.now() - renewSkew;
  }

  private buildPipeline(credential: TokenCredential) {
    const pipeline = MapsURL.newPipeline(credential);
    this.searchURL = new SearchURL(pipeline);
  }

  getLocationObject(place: any, county: string, address?: string, ) {
    const location_obj = {};
    if (place?.geometry?.coordinates && place.geometry?.coordinates.length > 1) {
      const geometry = {
        lat: place.geometry?.coordinates[1],
        lng: place.geometry?.coordinates[0]
      };
      location_obj['geometry'] = geometry;
    }
    if (place?.properties?.address) {
      location_obj['formatted_address'] = address ? address : place.properties?.address?.freeformAddress;
      location_obj['city'] = place.properties?.address?.localName;
      location_obj['state'] = place.properties?.address?.countrySubdivisionCode;
      location_obj['county'] = county;
      location_obj['street_number'] = place.properties?.address?.streetNumber;
      location_obj['route'] = place.properties?.address?.streetName;
      location_obj['country'] = place.properties?.address?.country;
      location_obj['postal_code'] = place.properties?.address?.postalCode;
    }
    return location_obj;

  }

  searchFuzzy(address: string | GeoJSON.Position) {
    return new Promise((resolve) => {
      if(this.searchURL) {
        //setTimeout(() => {
          this.searchURL.searchFuzzy(Aborter.timeout(5000), address, { typeahead: true, countrySet: ['US'] }).then(
            response => {
              resolve(response);
            }
          );
        //},500);
      }
    });
  }

  getAddressDetails(address: string) {
    //https://atlas.microsoft.com/geocode?api-version=2023-06-01&top={top}&query={query}&addressLine={addressLine}&countryRegion={countryRegion}&bbox={bbox}&view={view}&coordinates={coordinates}&adminDistrict={adminDistrict}&adminDistrict2={adminDistrict2}&adminDistrict3={adminDistrict3}&locality={locality}&postalCode={postalCode}
    const headers = new HttpHeaders ({
      'Accept-Language': 'en-US',
      'x-ms-client-id': this.azureMapClientID,
      'Authorization': 'Bearer ' + this.currentToken
    })
    return this.http.get(`https://atlas.microsoft.com/geocode?api-version=2023-06-01&query=${address}`, {headers});
    
  }

}

